import { State, Selector, Action, StateContext } from '@ngxs/store';
import { tap, catchError } from 'rxjs/operators';
import { SendMessageAction, SendMessageSuccessAction, SendMessageFailAction } from './contact.actions';
import { Injectable } from '@angular/core';
import { ContactService } from '@core/services';
import { OpenToastrAction } from '@ngxs-store/ui-store/ui.actions';
import { ToastrType } from '@core/models/ui/toastr-config';

export class ContactStateModel {
  public isLoading: boolean;
}

@State<ContactStateModel>({
  name: 'contact',
  defaults: {
    isLoading: false
  }
})
@Injectable()
export class ContactState {
  constructor(
    private contactClient: ContactService
  ) { }

  @Selector()
  static getIsLoading(state: ContactStateModel) {
    return state.isLoading;
  }

  @Action(SendMessageAction)
  sendMessageAction({ dispatch, patchState }: StateContext<ContactStateModel>, action: SendMessageAction) {
    patchState({ isLoading: true });

    return this.contactClient.sendEnquiry(action.payload.contact).pipe(
      tap(() => dispatch(new SendMessageSuccessAction())),
      catchError((err) => dispatch(new SendMessageFailAction()))
    );
  }

  @Action(SendMessageSuccessAction)
  sendMessageSuccessAction(ctx: StateContext<ContactStateModel>, action: SendMessageSuccessAction) {
    ctx.patchState({
      isLoading: false
    });
    ctx.dispatch(new OpenToastrAction({
        message: 'Thank you for your message.  SG Convenience will contact you shortly',
        type: ToastrType.success, title:'Status'
    }));
  }

  @Action(SendMessageFailAction)
  sendMessageFailAction(ctx: StateContext<ContactStateModel>, action: SendMessageFailAction) {
    ctx.patchState({
      isLoading: false
    });
  }
}
